module.exports = "/images/circle-marker-car.png?473b237f0cdde138adc079cf22ef8dab";